import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';

// const firebaseConfig = {
//   apiKey: "AIzaSyCPPZ9s-Ehszkx6DNRRwlnL3VfiZXB4UCc",
//   authDomain: "riv-expenser.firebaseapp.com",
//   projectId: "riv-expenser",
//   storageBucket: "riv-expenser.firebasestorage.app",
//   messagingSenderId: "",
//   appId: "",
// };

const firebaseConfig = {
  apiKey: "AIzaSyBzSlU9_uqMdFuTYbbEAHV7b5IHKNJ9ubU",
  authDomain: "riv-expenser.firebaseapp.com",  // TODO: Update this to your actual domain
  projectId: "riv-expenser",
  storageBucket: "riv-expenser.firebasestorage.app",
  messagingSenderId: "129740876222",
  appId: "1:129740876222:web:bcf53e84bc64f186f031ef",
  measurementId: "G-620E3Z24S8",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');
export const analytics = getAnalytics(app);
export const googleProvider = new GoogleAuthProvider();
